import React from "react";
import { useLocation, Navigate } from "react-router-dom";
import WHITE_PAPERS from "../data/whitePaperArticles";
import BLOG_POSTS from "../data/blogArticles";
import WhitePapersPost from "./WhitePaperArticle";
import BlogPost from "./BlogArticle";

export default function CatchAllArticle() {
  const { pathname } = useLocation();
  const slug = pathname.replace(/\/$/, "");

  const isWP = WHITE_PAPERS.some((p) => p.url.replace(/\/$/, "") === slug && p.body);
  if (isWP) return <WhitePapersPost />;

  const isBP = BLOG_POSTS.some((p) => p.url.replace(/\/$/, "") === slug && p.body);
  if (isBP) return <BlogPost />;

  return <Navigate to="/" replace />;
}
